import { INFO, FETCH_INFO_REQUEST, FETCH_INFO_SUCCESS, FETCH_INFO_FAILURE, INFO_RESET, InfoProps } from './types'

const initialState = {
  data: undefined,
  loading: false,
  init: false,
  error: undefined,
}

export const InfoReducer = (state: InfoProps = initialState, action: INFO): InfoProps => {
  const { data } = state
  const { type, payload } = action

  switch (type) {
    case FETCH_INFO_REQUEST:
      return { ...data, init: false, loading: true }
    case INFO_RESET:
      return { data: undefined, init: false, loading: false, error: undefined }
    case FETCH_INFO_SUCCESS:
      return { data: payload, loading: false, init: true, error: undefined }
    case FETCH_INFO_FAILURE:
      return { data, loading: false, init: true, error: payload }
    default:
      return state
  }
}
